module.exports = __webpack_public_path__ + "static/media/f_eyebrowshape_s_vector.0c3dc5df.svg";